import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { for: "old_password" }, "Nhập mật khẩu cũ", -1)
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_5 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "password" }, "Nhập mật khẩu mới (tối thiểu 6 ký tự)", -1)
const _hoisted_7 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { for: "password2" }, "Nhập lại mật khẩu mới", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Password = _resolveComponent("Password")
  const _component_Button = _resolveComponent("Button")
  const _component_Panel = _resolveComponent("Panel")

  return (_openBlock(), _createBlock(_component_Panel, { header: "Thay đổi mật khẩu" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Password, {
            id: "old_password",
            modelValue: $setup.password.old_password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.password.old_password = $event)),
            toggleMask: "",
            feedback: false
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Password, {
            id: "password",
            modelValue: $setup.password.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.password.password = $event)),
            toggleMask: "",
            feedback: true
          }, null, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_Password, {
            id: "password2",
            modelValue: $setup.password.password2,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.password.password2 = $event)),
            toggleMask: "",
            feedback: false
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(_component_Button, {
        label: "Lưu mật khẩu",
        icon: "pi pi-check",
        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changePassword())),
        disabled: !$setup.formValid()
      }, null, 8, ["disabled"])
    ]),
    _: 1
  }))
}